import * as React from 'react';
import { Alert } from '../Alert';

export const ErrorMessage = (props: { children: string }) => (
  <Alert severity='error'>{props.children}</Alert>
);
